// Opens native turn-by-turn directions to the given coords.
// Falls back to Google Maps web on desktop; iOS uses Apple Maps via the universal
// "maps.apple.com" link which respects the user's default maps app.
export function openDirections({ lat, lng, label, mode = "driving" } = {}) {
  if (lat == null || lng == null) return;
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent || "") && !window.MSStream;
  const dest = `${lat},${lng}`;
  const enc = (s) => encodeURIComponent(s || "Destination");

  let url;
  if (isIOS) {
    // Apple Maps deep link — dirflg: d=drive, w=walk, r=transit
    const dirflg = mode === "walking" ? "w" : mode === "transit" ? "r" : "d";
    url = `https://maps.apple.com/?daddr=${dest}&dirflg=${dirflg}&q=${enc(label)}`;
  } else {
    url = `https://www.google.com/maps/dir/?api=1&destination=${dest}&travelmode=${mode}&destination_name=${enc(label)}`;
  }
  window.open(url, "_blank", "noopener,noreferrer");
}
